import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setPageTitle } from '../../store/slices/pageTitleSlice';
import { CommandCenterGrid } from '../CommandCenter/CommandCenterGrid';
import { RootState } from "../../store";

export const ClinicalAlertsPatientDetail = () => {
    const { patientId } = useParams<{ patientId: string }>();
    const dispatch = useDispatch();
    const clinicalAlertReloadKey = useSelector((state: RootState) => state.clinicalAlertReloadKey.clinicalAlertReloadKey);
    useEffect(() => {
        dispatch(setPageTitle('Clinical Alerts: Patient Profile | Spire360'));
    }, []);
    return <CommandCenterGrid patientId={patientId}/>;
};